<template>
  <v-layout fill-height align-center>
    <v-spacer></v-spacer>
    <v-btn-toggle
      class="screen-mode-toggle-buttons"
      mandatory
      v-model="screenMode"
      color="secondary"
      light
    >
      <v-tooltip bottom nudge-bottom="5">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon value="lg" height="26">
            <v-icon size="23">mdi-laptop</v-icon>
          </v-btn>
        </template>
        <span>Desktop screen</span>
      </v-tooltip>

      <v-divider vertical></v-divider>

      <v-tooltip bottom nudge-bottom="5">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon value="sm" height="26">
            <v-icon size="18">mdi-tablet-android</v-icon>
          </v-btn>
        </template>
        <span>Tablet screen</span>
      </v-tooltip>

      <v-divider vertical></v-divider>

      <v-tooltip bottom nudge-bottom="5">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon value="xs" height="26">
            <v-icon size="17">mdi-cellphone</v-icon>
          </v-btn>
        </template>
        <span>Phone screen</span>
      </v-tooltip>
    </v-btn-toggle>

    <v-spacer></v-spacer>
  </v-layout>
</template>

<script>
export default {
  name: 'EditorScreenModeToggle',
  computed: {
    screenMode: {
      get() {
        return this.$store.state.editor.screenMode
      },
      set(value) {
        this.$store.commit('editor/SET_SCREEN_MODE', {
          name: value,
          size: this.$vuetify.breakpoint.thresholds[value]
        })
      }
    }
  }
}
</script>

<style>
.screen-mode-toggle-buttons
  .v-btn:not(.v-btn--text):not(.v-btn--outlined).v-btn--active:before {
  opacity: 1;
}
.screen-mode-toggle-buttons.v-btn-toggle:not(.v-btn-toggle--group)
  .v-btn.v-btn.v-item--active
  .v-icon {
  color: #ffffff !important;
}
.screen-mode-toggle-buttons .v-btn {
  border: none !important;
}
</style>
